import { z } from "zod";

export const AgendaItemSchema  = z.object({
  Id: z.number().optional(),
  SubTitle: z.string().optional(),
  Title: z.string().optional(),
  AgendaGroupId: z.number(),
  AgendaItemType: z.number(),
  PlenumID: z.number().optional().nullable(),
  NetworkingID: z.number().optional().nullable(),
  VODStartSecond: z.number().optional().nullable(),
  VODEndSecond: z.number().optional().nullable(),
  Speaker: z.string().optional(),
  URL: z.string().optional(),
  ButtonText: z.string().optional(),
  DateFrom: z.date(),
  DateTo: z.date(),
  Visible:z.boolean().default(true),
 
});



export const AgendaSchema = z.object({
  Id: z.number().optional(),
  EventId: z.string().uuid().optional().nullable(),
  OrderNumber: z.number().optional().nullable(),
  Title: z.string().optional().nullable(),
  SubTitle: z.string().optional(),
  Date: z.string().optional().nullable(),
  TabName: z.string().optional().nullable(),
   TimeZones: z.string().optional(),
  ShowInOneBlock: z.boolean().default(false),
  ShowICS: z.boolean().default(false),
  PlenumId: z.number().optional().nullable()

});


export type AgendaInfoSchema = {
  Id?:  number;
  EventId?: string | null;
  OrderNumber?: number | null;
  Title?: string | null;
  Date?: string | null;
  TabName?: string | null;
};

export type AgendaItemInfoSchema = {
  Id?:  number;
  Title?: string | null;
  DateFrom?: Date | string | null;
  DateTo?: Date | string | null;
  Visible?: boolean;
  AgendaItemType?: number;
};
